import { render } from "./new-big-image-with-tabs-block.vue?vue&type=template&id=e19f89ca"
import script from "./new-big-image-with-tabs-block.vue?vue&type=script&lang=js"
export * from "./new-big-image-with-tabs-block.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__